import api from './api';

export interface Sala {
  id: string;
  nome: string;
  tipo: 'Reunião' | 'Call';
  descricao?: string;
  capacidade?: number;
  recursos?: string[];
  ativa: boolean;
  em_manutencao?: boolean;
  cor: string;
  data_criacao: string;
}

export interface CriarSalaDTO {
  id: string;
  nome: string;
  tipo: 'Reunião' | 'Call';
  descricao?: string;
  capacidade?: number;
  recursos?: string[];
  cor?: string;
}

export interface AtualizarSalaDTO {
  nome?: string;
  tipo?: 'Reunião' | 'Call';
  descricao?: string;
  capacidade?: number;
  recursos?: string[];
  ativa?: boolean;
  cor?: string;
}

/**
 * Listar todas as salas
 */
export const listarSalas = async (apenasAtivas: boolean = true): Promise<Sala[]> => {
  const response = await api.get('/salas', {
    params: { ativas: apenasAtivas }
  });
  return response.data;
};

/**
 * Obter detalhes de uma sala
 */
export const obterSala = async (id: string): Promise<Sala> => {
  const response = await api.get(`/salas/${id}`);
  return response.data;
};

/**
 * Criar nova sala (apenas admin)
 */
export const criarSala = async (dados: CriarSalaDTO): Promise<Sala> => {
  const response = await api.post('/salas', dados);
  return response.data;
};

/**
 * Atualizar sala (apenas admin)
 */
export const atualizarSala = async (id: string, dados: AtualizarSalaDTO): Promise<Sala> => {
  const response = await api.put(`/salas/${id}`, dados);
  return response.data;
};

/**
 * Desativar sala (apenas admin)
 */
export const desativarSala = async (id: string): Promise<void> => {
  await api.delete(`/salas/${id}`);
};

export default {
  listarSalas,
  obterSala,
  criarSala,
  atualizarSala,
  desativarSala
};
